import { GameServices } from '../../services/game-services';
import { CroupierHandViewModel } from './croupier-hand-view-model';

export class CroupierBettingBoxViewModel {
  public readonly croupierHandViewModel: CroupierHandViewModel;

  constructor(gameServices: GameServices) {
    this.croupierHandViewModel = new CroupierHandViewModel(gameServices);
  }

  public resetGameScene() {
    this.croupierHandViewModel.resetGameScene();
  }
}
